
export interface IQuil {
    readonly?: boolean;
    placeholder?: string;
    onChange?: any;
    modules?: string;
    onkeypress?: any;
    value?: string;
    className?: string;
    theme?: string;
    id?: string;
}


export enum EModuleType {
    basic = 'basic',
    standart = 'standart',
    all = 'all',
    mobile = 'mobile'
}






